import type { Module } from 'vuex';
import { ICategory } from '../../entities/category-entity';
import {IMenuTreeItem} from "../../entities/menu-entity";
import {Category} from "sitisjs/dist/internal/sections/categories/models/Category";
import {IGetCategoryDetailedParams} from "../../../lib/store/modules/catalog-store";

export const namespace = 'sets';

export const MutationType = {
	SET_SETS: 'SET_SETS',
	SET_SET: 'SET_SET',
	SET_CATEGORY_DETAILED: 'setCategoryDetailed',
};
export const actionType = {
	GET_SETS: 'GET_SETS',
	GET_CATEGORY_DETAILED: 'GET_CATEGORY_DETAILED',
};



export default function setsStore(): Module<any, any> {
	return {
		namespaced: true,
		state: () => ({
			set: null,
			sets: [],
		}),
		actions: {
			async [actionType.GET_SETS]({ commit }): Promise<any> {
				try {
					commit('appState/setLoading', { sets: true }, { root: true });
					const res = await this.$api.set.getSets.execute({
						page: 1
					});
					const catalog = res.getValue();
					const sets = catalog?.sets || [];
					commit(MutationType.SET_SETS, sets);
					return sets;
				} finally {
					commit('appState/setLoading', { sets: false }, { root: true });
				}
			},
			async [actionType.GET_CATEGORY_DETAILED]({ commit, state, dispatch }, params: IGetCategoryDetailedParams): Promise<ICategory | undefined> {
				const {
					slug,
					extensions
				} = params;

				let filters = [];
				if ((extensions || []).length > 0) {
					filters.push(`expand=${extensions?.join(',')}`)
				}

				try {
					commit('appState/setLoading', { category: true }, { root: true });

					const filterString = Boolean(filters.length > 0) ? `?${filters.join("&")}` : "";
					const response = await this.$api.agent.transport.get(`/filter-pages/${ slug }${ filterString }`).then((res: any) => {
						return res.data
					}).catch(() => {
						return undefined
					})
					if (!response) {
						return undefined
					}

					const category = new Category(response);

					commit(MutationType.SET_CATEGORY_DETAILED, category || null);

					return category;
				} finally {
					// commit('appState/setLoading', { category: false }, { root: true });
				}
			},
		},
		mutations: {
			[MutationType.SET_SETS]: (state, sets: any[]) => {
				state.sets = sets;
			},
			[MutationType.SET_SET]: (state, set: any[]) => {
				state.set = set;
			},
			[MutationType.SET_CATEGORY_DETAILED]: (state, category: ICategory) => {
				state.set = category;
			},
		},
		getters: {
			set: ({ set }) => set,
			sets: ({ sets }): ICategory[] => sets
		},
	};
}
